import { Box, Button } from "@mui/material";

import DashboardIcon from "@mui/icons-material/Dashboard";
import AssignmentIcon from "@mui/icons-material/Assignment";
import SecurityIcon from "@mui/icons-material/Security";
import Logo from "../assets/logo.png";
export default function Sidebar({ sidebarOpen }) {
  return (
    <Box
      sx={{
        width: sidebarOpen ? 250 : 80,
        transition: "0.3s",
        background: "#07233d",
        borderRight: "1px solid rgba(255,255,255,0.08)",
        display: "flex",
        flexDirection: "column",
      }}
    >
      {/* LOGO */}
      <Box
        sx={{
          height: 65,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          borderBottom: "1px solid rgba(255,255,255,0.08)",
          px: 1,
        }}
      >
        <img src={Logo} width={"100%"} />
      </Box>

      {/* MENU */}
      <Box sx={{ p: 1.5 }}>
        <Button
          fullWidth
          sx={{
            justifyContent: sidebarOpen ? "flex-start" : "center",
            color: "#fff",
            py: 1.5,
            borderRadius: 3,
            background: "rgba(59,130,246,0.15)",
            mb: 1,
          }}
        >
          <DashboardIcon />
          {sidebarOpen && <Box sx={{ ml: 1 }}>All Claims</Box>}
        </Button>

        <Button
          fullWidth
          sx={{
            justifyContent: sidebarOpen ? "flex-start" : "center",
            color: "#94a3b8",
            py: 1.5,
            borderRadius: 3,
            mb: 1,
            textAlign: "start",
          }}
        >
          <AssignmentIcon />
          {sidebarOpen && <Box sx={{ ml: 1 }}>Weekly Discrepency Claims</Box>}
        </Button>

        <Button
          fullWidth
          sx={{
            justifyContent: sidebarOpen ? "flex-start" : "center",
            color: "#94a3b8",
            py: 1.5,
            borderRadius: 3,
          }}
        >
          <SecurityIcon />
          {sidebarOpen && <Box sx={{ ml: 1 }}>Protection Plan</Box>}
        </Button>
      </Box>
    </Box>
  );
}
